import fd from "./promise-fastdom";

customElements.define('toggle-tooltip', class extends HTMLElement {
    constructor() {
        super();
    }

    template(id) {
        const node = document.getElementById(id);
        if (node) {
            return node.content;
        } else {
            const template = document.createElement('template');
            template.innerHTML = `
        <button type="button" part="button" aria-label="Infos">
            <slot name="toggle">i</slot>
        </button>
        <div role="status" aria-live="polite"></div>
        `;
            return template.content;
        }

    }

    // noinspection JSUnusedGlobalSymbols
    connectedCallback() {
        const self = this;
        const template = this.template(this.getAttribute('template') || 'toggle-tooltip-template');
        const shadow = this.attachShadow({mode: 'open'})

        const content = document.createElement('span');
        content.innerText = this.getAttribute('title');
        content.setAttribute('part', 'content');
        this.removeAttribute('title');

        shadow.appendChild(template.cloneNode(true));

        const live = shadow.querySelector('[role="status"]');
        const button = shadow.querySelector('button');
        
        if (this.getAttribute('label')) {
            button.setAttribute('aria-label', this.getAttribute('label'));
        }

        function enable() {
            content.remove();
            setTimeout(() => {
                return fd.mutate(() => {
                    live.appendChild(content);
                    self.classList.add('enabled');
                });
            }, 100);
        }

        function disable() {
            content.remove();
            self.classList.remove('enabled');
        }

        button.addEventListener('click', enable);
        button.addEventListener('blur', disable);

        document.addEventListener('keydown', (e) => {
            if (e.code === 'Escape') {
                disable();
            }
        });

        document.addEventListener('click', (e) => {
            if (e.target !== self && !self.contains(e.target)) {
                disable();
            }
        });
    }
});